import { render } from "./PageEvent.vue?vue&type=template&id=d35426aa&scoped=true"
import script from "./PageEvent.vue?vue&type=script&lang=js"
export * from "./PageEvent.vue?vue&type=script&lang=js"

import "./PageEvent.vue?vue&type=style&index=0&id=d35426aa&scoped=true&lang=css"

import exportComponent from "/home/xs551928/niidaphoto.com/oyadori/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d35426aa"]])

export default __exports__